import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import {ViewCell} from '@mominsamir/ngx-smart-table';
import {FormControl} from '@angular/forms';
import {Unsubscribable} from '@core/interfaces/unsubscribable';
import {distinctUntilChanged, startWith, takeUntil} from 'rxjs/operators';
import {combineLatest, Observable, of} from 'rxjs';
import {GeneralOption} from '@core/interfaces/system/system-common';

@Component({
    selector: 'ngx-dropdown-cell',
    template: `
        <div class="action-cell">
            <nb-select fullWidth [class.pointer-none]="disabled(rowData)" [formControl]="formControl">
                <nb-select-label [nbTooltip]="selectedLabelFormatter(rowData, formControl.value)">
                    {{ selectedLabelFormatter(rowData, formControl.value) }}
                </nb-select-label>
                <nb-option *ngFor="let option of optionsList$ | async" [value]="option">
                    {{ option.label }}
                </nb-option>
            </nb-select>
        </div>
    `,
    styleUrls: ['./dropdown-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownCellComponent<T> extends Unsubscribable implements OnInit, ViewCell {
    @Input() value: any;
    @Input() rowData: T;
    @Input() optionsList$: Observable<GeneralOption[]>;
    @Input() disabled = (rowData: T) => false;
    @Input() getPreselectedValue = (rowData: T) => this.value;
    @Input() refresh$: Observable<boolean> = of(true);
    @Input() selectedLabelFormatter = (rowData: T, selectedValue: GeneralOption) => selectedValue.label;
    @Output() onSelectChange: EventEmitter<{selectedValue: GeneralOption; rowData: T}> = new EventEmitter();

    formControl: FormControl = new FormControl();

    constructor(private cd: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {
        combineLatest([this.optionsList$.pipe(distinctUntilChanged()), this.refresh$.pipe(startWith(true))])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(([array, _]: [GeneralOption[], boolean]) => {
                this.formControl.setValue(
                    array.find((o) => o.value === this.getPreselectedValue(this.rowData)),
                    {emitEvent: false},
                );

                setTimeout(() => this.cd.detectChanges()); //use setTimeout to detectChanges after formControl will be set
            });
        this.disabled(this.rowData) && this.formControl.disable();

        this.formControl.valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((selectedValue: GeneralOption) =>
                this.onSelectChange.emit({selectedValue, rowData: this.rowData}),
            );
    }
}
